/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_PrivateInputs */



/**
* | output |
* | --- |
* | "Private" |
*
* @param {Og_Cfg_PrivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_private = /** @type {((inputs?: Og_Cfg_PrivateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_PrivateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Privé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Privada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Privada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Privata")
	return /** @type {LocalizedString} */ ("Private")
});